export const statusFilter = (status, list) => {
  return status === 'Todos'
    ? list
    : list.filter(item => item.status.toUpperCase() === status.toUpperCase())
}
